import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { downloadBase64File } from 'src/app/utils/pdf-downloader';
import { sweetAlert } from 'src/app/utils/swal';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { ReportService } from '../reports-service/report.service';

@Component({
  selector: 'app-driver-earnings',
  templateUrl: './driver-earnings.component.html',
  styleUrls: ['./driver-earnings.component.css']
})
export class DriverEarningsComponent implements OnInit, OnDestroy {
  user;
  search;
  drivers;
  selectedDriver;
  timeline;
  timelines;
  view = 'history';
  isShowBreakPopup = false;
  applyCaTimeSheet = false;
  currentDateTime = moment().startOf('day');
  preDateRange = [
    moment().startOf('day'),
    moment().endOf('day')
  ]
  dateRange = [
    moment().startOf('day').toISOString(),
    moment().endOf('day').toISOString()
  ];
  break;

  // dates = {
  //   startDate: moment().startOf('day'),
  //   endDate: moment().endOf('day')
  // };
  timeZone;

  isHistoryData: boolean = false;
  isTodayData: boolean = false;
  isSelectedDriver: boolean = false;

  isBreakSubmitted = false;
  isTimelineSubmitted = false;
  breakDetail: boolean = false;
  editShift: boolean = false;
  selectedBreak = {
    time: moment().set({ 'hours': 0, 'minutes':5 }),
    min: moment().set({ 'hours': 0, 'minutes': 1 }),
    max: moment().set({ 'hours': 23, 'minutes': 59}),
  }
  @ViewChild('btnCloseTimelineModal', { static: false }) btnClose: ElementRef;


  driverEarnings: any;
  driverTrips: any;

  constructor(
    private reportService: ReportService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.applyCaTimeSheet = this.user.applyCaTimeSheet;
          this.timeZone = this.user.timeZone;
          this.dateRange = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          this.getDrivers();
        }
      });
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.drivers = data;
        }
      });
  }

  onSelectDriver(driver) {
    this.selectedDriver = driver;
    this.getDriverEarnings();
  }

  getDriverEarnings() {
    this.driverEarnings = null;
    this.driverTrips = null;

    if (!this.selectedDriver) return;

    let queryString = {
      driver: this.selectedDriver._id,
      startDate: this.dateRange[0],
      endDate: this.dateRange[1] 
    };

    this.reportService
      .getDriversEarnings(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          const [earnings] = data;
          const {trips} = earnings;
          this.driverTrips = trips;
          this.driverEarnings = earnings;
        }
      });
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  onChangeDate(evt) {
    this.dateRange = [evt[0].tz(this.timeZone).startOf('day').toISOString(), evt[1].tz(this.timeZone).endOf('day').toISOString()];
    this.getDriverEarnings();
  }

  generateCSVReport(){
   const date = { "startDate": this.dateRange[0], "endDate": this.dateRange[1] }
   this.csvService.driverEarningsReport(this.driverEarnings, date, this.selectedDriver, this.timeZone);
  }
  
  ngOnDestroy(): void {
  }

}
